import "./Live.module.css";
import Header from "@/reusable_sections/Header";
import VideoLiveUtama from "./sections/VideoLiveUtama";
import MediaGrid from "./sections/MediaGrid";
import JadwalLiveMendatang from "./sections/JadwalLiveMendatang";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function LivePage() {
  return <div>
      <Header />
      <VideoLiveUtama />
      <MediaGrid />
      <JadwalLiveMendatang />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}